<script>
import ListingModel from "@/views/Edms/Template/Components/ListingModel.vue";

export default {
    components: {ListingModel},
}
</script>

<template>
    <ListingModel type="FOOTER"/>
</template>